import { render, staticRenderFns } from "./TaxTransitionMethodology.vue?vue&type=template&id=802b69ee&"
import script from "./TaxTransitionMethodology.vue?vue&type=script&lang=js&"
export * from "./TaxTransitionMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports